import React, { useContext } from 'react';
import { IonList, IonItem, IonIcon, IonLabel, IonBadge } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { 
  chatboxOutline, 
  peopleOutline, 
  albumsOutline, 
  personOutline,
  calendarOutline,
  notificationsOutline,
  globeOutline,
  cashOutline,
} from 'ionicons/icons';
import { ProfileContext } from '../../context/ProfileContext';
import { SchedJobContext } from '../../context/JobContextScheduler';

export const WebSidebar: React.FC = () => {
  const location = useLocation();
  
  const { 
    profilePicBadge,
    badgeCountAssociateRequestsContext,
    badgeCountDMContext,
    badgeCountNotificationsContext,
  } = useContext(ProfileContext);
  
  const { badgeCountHeaderToggleSchedulerContext } = useContext(SchedJobContext);

  const navItems = [
    { 
      path: '/Chats', 
      icon: chatboxOutline, 
      label: 'Messages',
      badge: badgeCountDMContext 
    },
    { 
      path: '/Associates', 
      icon: peopleOutline, 
      label: 'Associates',
      badge: badgeCountAssociateRequestsContext 
    },
    { 
      path: '/Home', 
      icon: albumsOutline, 
      label: 'Werk',
      badge: badgeCountHeaderToggleSchedulerContext 
    },
    {
      path: '/payments',
      icon: cashOutline,
      label: 'Payments',
      badge: 0,
    },
    { 
      path: '/Calendar', 
      icon: calendarOutline, 
      label: 'Calendar',
      badge: 0 
    },
    {
      path: '/notifications',
      icon: notificationsOutline,
      label: 'Notifications',
      badge: badgeCountNotificationsContext,
    },
    { 
      path: '/Profile', 
      icon: personOutline, 
      label: 'Profile',
      badge: profilePicBadge === 1 ? 1 : 0 
    },
  ];

  return (
    <IonList style={{ position: 'sticky', top: '20px' }}>
      {navItems.map((item) => (
        <IonItem
          key={item.path}
          button
          routerLink={item.path}
          routerDirection="root"
          color={location.pathname.toLowerCase() === item.path.toLowerCase() ? 'light' : undefined}
          lines="none"
          style={{
            marginBottom: '8px',
            borderRadius: '8px',
            fontWeight: location.pathname.toLowerCase() === item.path.toLowerCase() ? 'bold' : 'normal'
          }}        >
          <IonIcon icon={item.icon} slot="start" />
          <IonLabel>{item.label}</IonLabel>
          {item.badge > 0 && <IonBadge color="danger">{item.badge}</IonBadge>}
        </IonItem>
      ))}
      
      {/* Separator */}
      <div style={{ 
        borderTop: '1px solid #ddd', 
        margin: '16px 8px', 
      }} />
      
      {/* Link to Public Website */}
      <IonItem
        button
        routerLink="/"
        routerDirection="root"
        color={location.pathname === '/' ? 'light' : undefined}
        lines="none"
        style={{
          marginBottom: '8px',
          borderRadius: '8px',
          fontWeight: location.pathname === '/' ? 'bold' : 'normal'
        }}
      >
        <IonIcon icon={globeOutline} slot="start" />
        <IonLabel>Public Website</IonLabel>
      </IonItem>
    </IonList>
  );
};

export default WebSidebar;
